<div class="grid-profile-toolbar">
  <dx-select-box
    [dataSource]="profiles"
    displayExpr="profile_name"
    valueExpr="id"
    [value]="selectedProfileId"
    (onValueChanged)="onProfileSelected($event)"
    placeholder="None (Default)"
    [showClearButton]="true"
    [width]="220"
  ></dx-select-box>

  <dx-button
    text="Save"
    icon="save"
    stylingMode="outlined"
    [disabled]="!selectedProfileId"
    (onClick)="onSaveClick()"
  ></dx-button>

  <dx-button
    text="Save As"
    icon="plus"
    stylingMode="outlined"
    (onClick)="onSaveAsClick()"
  ></dx-button>

  <dx-button
    text="Delete"
    icon="trash"
    stylingMode="outlined"
    type="danger"
    [disabled]="!selectedProfileId"
    (onClick)="onDeleteClick()"
  ></dx-button>
</div>

<dx-popup
  [visible]="saveAsPopupVisible"
  [dragEnabled]="false"
  [showCloseButton]="true"
  [showTitle]="true"
  title="Save Profile As"
  [width]="350"
  [height]="220"
  (onHiding)="onSaveAsCancel()"
>
  <div class="save-as-form">
    <dx-text-box
      [(value)]="newProfileName"
      placeholder="Enter profile name"
      [width]="'100%'"
    ></dx-text-box>
    <dx-check-box
      [(value)]="newProfileIsDefault"
      text="Set as default"
    ></dx-check-box>
    <div class="save-as-actions">
      <dx-button
        text="Save"
        type="default"
        stylingMode="contained"
        (onClick)="onSaveAsConfirm()"
      ></dx-button>
      <dx-button
        text="Cancel"
        stylingMode="outlined"
        (onClick)="onSaveAsCancel()"
      ></dx-button>
    </div>
  </div>
</dx-popup>
